<template>
  <a-forgot-password-widget></a-forgot-password-widget>
</template>

<script>
export default {
  name: 'ForgotPasswordPage',
}
</script>